import * as React from 'react';
import { SVGProps } from 'react';

const IconMaxHeightSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 12v-1h3.5l-2-2h2V3h-2l2-2H2V0h8v1H6.5l2 2h-2v6h2l-2 2H10v1H2z" />
  </svg>
);
export default IconMaxHeightSizeXs;
